import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import module from 'app/store/seatPlan';
import modulesessionTicket from 'app/store/sessionsTickets';
import { useLocation } from 'react-router-dom';

const { planRequest, clearPlan } = module.actions;
const { requestSesseionsSeatPlan, clearSesseionSeatPlan } = modulesessionTicket.actions;

export default function (cinemaId, sessionId, userSessionId, isPlanExist) {
  const dispatch = useDispatch();
  const location = useLocation();
  const email = location?.state?.email;
  const promotionId = location?.state?.promotionId;
  useEffect(() => {
    if (!isPlanExist) {
      if (email) {
        dispatch(requestSesseionsSeatPlan({ cinemaId: cinemaId, email: email, promotionId: promotionId }));
      }
      else {
        dispatch(planRequest(cinemaId, sessionId));
      }
      // dispatch(planRequest(cinemaId, sessionId, userSessionId));
    }
  }, [cinemaId, sessionId, userSessionId, isPlanExist, dispatch]);

  // TODO: check why this method can't be placed inside the first effect
  useEffect(() => () => {
    if (email) {
      dispatch(clearSesseionSeatPlan());
    }
    else {
      dispatch(clearPlan());
    }
  }, [dispatch]);
  // useEffect(() => () => dispatch(clearSesseionSeatPlan()), [dispatch]);
}
